export const schoolSyllabusList = ['CBSE', 'ICSE', 'IGCSE', 'IB', 'State Board'];

export const schoolSubjectList = [
  'Math',
  'Science',
  'English',
  'Social Studies',
  'Computer Science',
  'Physics',
  'Chemistry',
  'Biology',
  'Economics',
  'Ask Anything'
];

export const collegeUniversityList = [
  'Kerala University',
  'Calicut University',
  'Kochin University'
];

export const collegeProgramList = [
  'Engineering',
  'Medicine',
  'B.Sc',
  'M.Sc'
];

export const collegeStreamMap = {
  Engineering: [
    'Computer Science Engineering',
    'Electronics and Communication',
    'Mechanical Engineering',
    'Civil Engineering'
  ],
  Medicine: [
    'MBBS',
    'Pharmacology',
    'Anatomy'
  ],
  'B.Sc': [
    'Physics',
    'Chemistry',
    'Mathematics',
    'Computer Science'
  ],
  'M.Sc': [
    'Physics',
    'Chemistry',
    'Mathematics',
    'Data Science'
  ]
};

export const collegeLevelMap = {
  Engineering: ['S1-S2', 'S3', 'S4', 'S5', 'S6'],
  Medicine: ['Year 1', 'Year 2', 'Year 3', 'Year 4'],
  'B.Sc': ['Year 1', 'Year 2', 'Year 3'],
  'M.Sc': ['Semester 1', 'Semester 2', 'Semester 3', 'Semester 4']
};

export const collegeSubjectMap = {
  Engineering: {
    'Computer Science Engineering': ['Programming in C', 'Data Structures', 'DBMS', 'Operating Systems', 'Ask Anything'],
    'Electronics and Communication': ['Circuit Theory', 'Signals and Systems', 'Digital Electronics', 'Ask Anything'],
    'Mechanical Engineering': ['Engineering Mechanics', 'Thermodynamics', 'Fluid Mechanics', 'Ask Anything'],
    'Civil Engineering': ['Surveying', 'Structural Analysis', 'Geotechnical Engineering', 'Ask Anything']
  },
  Medicine: {
    MBBS: ['Anatomy', 'Physiology', 'Biochemistry', 'Ask Anything'],
    Pharmacology: ['General Pharmacology', 'Clinical Pharmacology', 'Ask Anything'],
    Anatomy: ['Gross Anatomy', 'Histology', 'Ask Anything']
  },
  'B.Sc': {
    Physics: ['Mechanics', 'Optics', 'Electromagnetism', 'Ask Anything'],
    Chemistry: ['Organic Chemistry', 'Inorganic Chemistry', 'Physical Chemistry', 'Ask Anything'],
    Mathematics: ['Calculus', 'Linear Algebra', 'Differential Equations', 'Ask Anything'],
    'Computer Science': ['Programming Fundamentals', 'Discrete Mathematics', 'Data Structures', 'Ask Anything']
  },
  'M.Sc': {
    Physics: ['Quantum Mechanics', 'Statistical Physics', 'Ask Anything'],
    Chemistry: ['Spectroscopy', 'Advanced Organic Chemistry', 'Ask Anything'],
    Mathematics: ['Real Analysis', 'Topology', 'Ask Anything'],
    'Data Science': ['Machine Learning', 'Statistics', 'Data Mining', 'Ask Anything']
  }
};
